var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFyxdLoadingLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 100,
    viewBox: "0 0 99 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter0_d_4222_33950)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 83,
    height: 84,
    rx: 8,
    fill: "#252526",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M61.8386 48.7408C62.8669 49.7538 63.8953 50.7668 63.8953 50.7668C65.2805 49.4023 65.2875 48.0447 63.9163 46.694C62.888 45.681 62.2024 45.0057 62.2059 44.3269C60.4744 46.0325 60.4674 47.3901 61.8386 48.7408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M62.1394 57.2241C62.1429 56.5453 62.8355 55.8631 63.8744 54.8397C65.2595 53.4752 65.2666 52.1176 63.8954 50.7669C63.8954 50.7669 62.8565 51.7903 61.8177 52.8137C60.4325 54.1782 60.4255 55.5358 62.1394 57.2241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.665 36.8982C53.976 36.9016 53.2904 36.2263 52.262 35.2133C50.8909 33.8626 49.5127 33.8695 48.1275 35.234C48.1275 35.234 49.1559 36.247 50.1843 37.2601C51.5554 38.6107 52.9336 38.6038 54.665 36.8982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M46.0502 37.2809C47.089 36.2575 48.1279 35.2341 48.1279 35.2341C46.7568 33.8835 45.3786 33.8904 43.9934 35.2549C42.9546 36.2782 42.262 36.9605 41.5729 36.964C43.2868 38.6523 44.665 38.6454 46.0502 37.2809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M62.2068 44.3268C63.9383 42.6212 63.9453 41.2636 61.8886 39.2376L59.8319 37.2116C57.7751 35.1856 56.397 35.1925 54.6655 36.8981C55.3546 36.8946 56.3979 37.8929 57.7541 39.2583L59.8108 41.2844C61.1673 42.6494 62.2103 43.6481 62.2068 44.3268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5723 36.9639C39.8583 35.2755 38.4802 35.2824 36.4024 37.3292L34.3246 39.3759C32.2469 41.4227 32.2398 42.7803 33.9538 44.4686C33.9573 43.7898 34.9813 42.7518 36.3814 41.402L38.4591 39.3552C39.8588 38.005 40.8832 36.9673 41.5723 36.9639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5211 64.729C56.235 66.4173 57.6132 66.4104 59.6909 64.3637L61.7687 62.3169C63.8465 60.2701 63.8535 58.9126 62.1396 57.2242C62.136 57.903 61.112 58.941 59.712 60.2909L57.6342 62.3376C56.2346 63.6879 55.2102 64.7255 54.5211 64.729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7227 46.582H29.0792V49.5163H23.5422V51.1345H27.5283V53.8159H23.5422V58.3684H19.7227V46.582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0629 53.8838L29.3564 46.582H33.4349L35.9829 50.6451L38.6951 46.582H42.7555L37.8824 53.8838V58.3684H34.0629V53.8838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5179 52.4506L42.9037 46.582H47.2769L49.6942 49.6686L52.1295 46.582H56.5027L51.8885 52.4506L56.5386 58.3684H52.1654L49.6917 55.2327L47.218 58.3684H42.8447L47.5153 52.4506H47.5179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3672 46.269H71.9815C73.3596 46.269 74.5621 46.5152 75.5889 47.0051C76.6157 47.4974 77.4123 48.2018 77.9764 49.1206C78.5406 50.0395 78.8226 51.1119 78.8226 52.3402C78.8226 54.3753 78.2115 55.9181 76.9868 56.9637C75.7645 58.0117 74.0821 58.5333 71.9444 58.5333H67.3672V46.2666V46.269ZM72.2116 55.4818C73.1271 55.4818 73.8297 55.2016 74.3221 54.6386C74.8144 54.078 75.0619 53.3103 75.0619 52.3402C75.0619 51.475 74.812 50.756 74.3147 50.1808C73.8174 49.6056 73.132 49.3205 72.2661 49.3205H71.0537V55.4794H72.2116V55.4818Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4222_33950",
    x: 0,
    y: 0,
    width: 99,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4222_33950"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4222_33950",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFyxdLoadingLogo);
export default __webpack_public_path__ + "static/media/fyxd-loading-logo.e975d76874b37b6f998d44c02870ed45.svg";
export { ForwardRef as ReactComponent };